import { useQuery } from "@tanstack/react-query";
import { instance } from "../../axios.config";

export const useBlogs = (params) => {
  return useQuery({
    queryKey: ["blogs", params],
    queryFn: async () => {
      const {
        data: { data },
      } = await instance.get("blogs", { params });
      return data;
    },
  });
};

export const useBlog = (slug) => {
  return useQuery({
    queryKey: ["blog", slug],
    queryFn: async () => {
      const {
        data: { data },
      } = await instance.get(`blogs/${slug}`);
      return data;
    },
  });
};
